import { initializeFirebase } from "./firebase/firebaseConfig.js";
import { waitForAuth } from "./firebase/auth.js";
import { GameClient } from "./game/GameClient.js";
import { initializeUI, createWelcomeScreen, createWaitingScreen } from "./ui/ui.js";

const app = initializeFirebase();

import { AudioManager } from "./audio/AudioManager.js";
import { preloadSounds } from "./audio/sounds.js";
export const audio = new AudioManager();

function onFirstGesture() {
  document.removeEventListener("pointerdown", onFirstGesture);
  audio.createContext();
  if (audio.ctx.state === "suspended") {
    audio.ctx.resume();
  }
  preloadSounds(audio);
  console.log("Audio ready");
}

document.addEventListener("pointerdown", onFirstGesture, { once: true });

async function onFirstInteraction() {
  document.removeEventListener("pointerdown", onFirstInteraction);
  await audio.init();
  await Promise.all([
  ]).catch((err)=>{
    console.error(err);
  });
}

function getInviteId() {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.get('invite');
}

async function bootstrap() {
  const user = await waitForAuth();
  const userId = user.uid;
  const gameClient = new GameClient(userId);
  window.gameClient = gameClient; // For debugging
  console.log("User created with uid:", userId);

  // TODO: check that userId has no current matches!

  initializeUI(gameClient);
  let matchId = getInviteId();
  if (matchId != null) {
    gameClient.player = "player2";
    createWaitingScreen(matchId);
  } else {
    createWelcomeScreen();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  bootstrap().catch(err => {
    console.error("Fatal startup error:", err);
  });
});


